"use strict";
angular.module("timeLineItemModule", []).directive("timelineitem", function($filter) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            tick: "="
        },
        transclude: true,
        template: "<div class='time_item'><div class='time_tick'><span class='circle2'>{{tick}}</span><div class='time_item_cnt' ng-transclude></div></div></div>",
        link: function(scope) {
            if (angular.isString(scope.tick)) {
                scope.tick = scope.tick.replace(/-/g, '/');
            }
        }
    };
});